import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { companyService } from '../../../services/companyService';

/**
 * Custom hook for managing company data operations
 * Handles: loading, CRUD operations, error handling, authentication
 */
export const useCompanyManagement = () => {
  const navigate = useNavigate();
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const adminToken = localStorage.getItem('adminToken');
    if (!adminToken) {
      navigate('/admin-login');
      return;
    }
    loadCompanies();
  }, [navigate]);

  const loadCompanies = async () => {
    try {
      setLoading(true);
      setError('');
      const data = await companyService?.getAll();
      setCompanies(data);
    } catch (err) {
      console.error('Error loading companies:', err);
      setError(err?.message || 'Failed to load companies');
    } finally {
      setLoading(false);
    }
  };

  const handleToggleStatus = async (companyId, currentStatus) => {
    try {
      await companyService?.toggleStatus(companyId, !currentStatus);
      await loadCompanies();
    } catch (err) {
      console.error('Error toggling company status:', err);
      setError(err?.message || 'Failed to update company status');
    }
  };

  const handleDeleteCompany = async (companyId) => {
    if (!window.confirm('Are you sure you want to delete this company? This action cannot be undone.')) {
      return;
    }

    try {
      await companyService?.delete(companyId);
      await loadCompanies();
    } catch (err) {
      console.error('Error deleting company:', err);
      setError(err?.message || 'Failed to delete company');
    }
  };

  return {
    companies,
    loading,
    error,
    handleToggleStatus,
    handleDeleteCompany,
    reloadCompanies: loadCompanies
  };
};